module.exports = __webpack_public_path__ + "img/7.922c2571.jpeg";